import { SxProps, Theme } from '@mui/material';

export const PasswordInputSx: Record<string, SxProps<Theme>> = {
	iconButton: {
		width: 28,
		height: 28,
		padding: 0,
		minWidth: 0,
		color: 'grey.300',
		'.MuiSvgIcon-root': {
			fontSize: '18px',
			marginRight: '5px',
		},
		'&:hover': {
			backgroundColor: 'white',
			border: 'none',
		},
	},
	helperText: {
		ml: '0',
		fontSize: '10px',
	},
};
